import { Checkbox, Collapse, Modal, Row, message } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { getHasCompanyCard, productType } from "../../extensions/helper";
import { useWindowWidth } from "@react-hook/window-size";
import { serverFetch } from "../../server";
import { PayButtons } from "../../controls";
import { closePaymentWindow, navigateToPayment, preparePaymentWindow, shouldOpenPaymentWindow } from "../../extensions/payment-window";
const { Panel } = Collapse;

const PayItem = ({...props}) => {
    const {onCancel, item} = props;
    const user = useSelector((s) => s.user);
    const [cond1, setCond1] = useState(true);
    const [cond2, setCond2] = useState(true);
    const [cond3, setCond3] = useState(true);
    const [condF, setCondF] = useState(true);
    //const [autopay, setAutopay] = useState(false);
    const company = useSelector((s) => s.company);
    const [loading, setLoading] = useState(false);
    const onlyWidth = useWindowWidth();

    const DisablePayment = !company || !getHasCompanyCard(company) || !item || (!item.totalPrice && !item.debet) || !cond1 || !cond2 || !condF 
        || (!cond3 && item.autopay)
        || (item.productType === productType.Certificate && !item.receiverEmail)
        || loading;


    //console.log(item);
    let totalPrice = item.debet;
    const commission = Math.round(company && company.prcCommission > 0 ? totalPrice*company.prcCommission : 0)/100;
    totalPrice = totalPrice + commission;

    const divCommission = commission === 0 ? null : <>
        <Row>Комиссия {commission.toLocaleString()} ₽</Row>
        <Row><b>ИТОГО {totalPrice.toLocaleString()} ₽</b></Row>
    </>

    const onPayNew = ({ saleId, paymentSystem, autopay }, paymentWindow) => {
        serverFetch(`payment/${saleId ? "sale" : "debet"}`, {method: "POST", bodyData: { saleId: saleId, paymentSystem, autopay }})
            .then(data => {
                const opened = navigateToPayment(data, paymentSystem, paymentWindow);
                if (!opened) message.error('Разрешите всплывающие окна для перехода к оплате');
            })
            .catch(data => {
                closePaymentWindow(paymentWindow);
                message.error(data.UserMessage);
            })
    }

    const onPay = (system) => {
        const paymentWindow = preparePaymentWindow(system);
        if (shouldOpenPaymentWindow(system) && !paymentWindow) {
            message.error('Разрешите всплывающие окна для перехода к оплате');
            return;
        }

        const sale = {
            companyId: company.id,
            productId: 0, //item.idVidCard,
            productExternalId: `${item.idVidCard}`,
            price: item.debet,
            qty: 1,
            commission,
            totalPrice,
            autopay: item.autopay,
            externalId: item.idAbon,
        };
        setLoading(true);
        serverFetch(`sale`, { method: 'POST', bodyData: sale }, user)
            .then(data => onPayNew(
                { saleId: data.id, paymentSystem: system, autopay: false },
                paymentWindow
            ))
            .catch((e) => {
                closePaymentWindow(paymentWindow);
                setLoading(false);
                e.UserMessage && message.error(e.UserMessage);
            });
    };

    const offerAutopay = company && company.offerAutopay ? company.offerAutopay : process.env.REACT_APP_OFFER_AUTOPAY;
    const offerPayment = company && company.offerPayment ? company.offerPayment : process.env.REACT_APP_OFFER_PAYMENT;
    const divAutopayCondition = item && item.autopay ? <Panel header="Условия сервиса “Автоплатеж”" key="3">
        Условия пользования сервисом «Автоплатеж» в соответствии со ст.435 ГК РФ являются офертой, адресованной Пользователю. Пользователь, как держатель банковской карты, 
        производя оплату соглашается с <a href={offerAutopay} target='_blank' rel="noreferrer">Условиями</a>
    </Panel> : null
    const divAutopay = item && item.autopay ? 
        <Checkbox onChange={(e) => setCond3(e.target.checked)} defaultChecked={cond3}>Я согласен с сохранением данных карты и условиями сервиса "Автоплатеж"</Checkbox> : null

    return<Modal title={item.name} forceRender open={true} onCancel={onCancel} closable={false} footer={null}>
        <div className='catalog-item-price' style={{ marginTop: 16, marginBottom: 16 }}>{item.debet}</div>
        {divCommission}
        <div className='catalog-space'></div>
        <Collapse size="small" accordion>
            <Panel header="Условия платежа" key="1">
                Соглашаясь с <a href={offerPayment} target='_blank' rel="noreferrer">Условиями</a> платежа, вы соглашаетесь с составом и стоимостью заказа, а также с суммой комиссии, если она указана в заказе. Пожалуйста, внимательно ознакомьтесь с наименованием состава заказа, стоимостью заказа и описанием предоставления заказа.
            </Panel>
            <Panel header="Условия аннуляции заказа" key="2">
            Для аннуляции оплаченного заказа вы можете обратиться с Заявлением на возврат суммы оплаты на вашу банковскую карту к Поставщику услуг, указанному в чеке, или на e-mail Компании Проффит: inbox@fitnessoft.ru Аннуляция заказа и возврат оплаты возможны до начала использования заказа. В случае  аннулирования заказа Поставщик услуг имеет право взимать с клиента сервисный сбор в размере фактически понесенных расходов. Сервисный сбор включается в стоимость заказа. Размер сервисного сбора не может превышать 5% от оплаченной клиентом суммы. При аннуляции заказа до момента использования заказа денежные средства будут возвращены на банковскую карту,  которой была произведена оплата услуги в течение 10 рабочих дней с момента получения  Поставщиком услуг Зявления на возврат. В случае аннуляции заказа после начала использования заказа для возврата денежных средств вам необходимо обратиться непосредственно к Поставщику услуг для расчёта и возврата  остатка стоимости заказа.
            </Panel>
            {divAutopayCondition}
        </Collapse>
        <div><Checkbox onChange={(e) => setCond1(e.target.checked)} defaultChecked={cond1}>Я согласен с условиями платежа</Checkbox></div>
        <div><Checkbox onChange={(e) => setCond2(e.target.checked)} defaultChecked={cond2}>Я согласен с условиями аннуляции заявки</Checkbox></div>
        {divAutopay}
        {company && <PayButtons 
            company={company}
            isMobile={onlyWidth < 700}
            onPay={onPay}
            disablePayment={DisablePayment}
            autopay={item.autopay}
            price={item.debet}
            onBack={onCancel} />}
    </Modal>
}

export default PayItem